import { CreditsBalance } from "shared/utils/credits"
import { creditLabel } from "./utils/credits"

import styles from "./credit_summary.module.scss"

interface Props {
  runCost: number
  balance: CreditsBalance
}

const CreditSummary = ({ runCost, balance }: Props) => (
  <div className={styles["credit-summary"]}>
    <span className={styles.estimate}>Estimated {creditLabel(runCost)}/Applet run</span>
    <span className={styles.remaining}>{creditLabel(balance.remaining)} remaining this month</span>
  </div>
)

export default CreditSummary
